"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const block_content_to_react_1 = __importDefault(require("@sanity/block-content-to-react"));
const AsideSerializer_1 = __importDefault(require("./serializers/AsideSerializer"));
const ContactUsSerializer_1 = __importDefault(require("./serializers/ContactUsSerializer"));
const ImageSerializer_1 = __importDefault(require("./serializers/ImageSerializer"));
const InternalLinkSerializer_1 = __importDefault(require("./serializers/InternalLinkSerializer"));
const ScreenshotSerializer_1 = __importDefault(require("./serializers/ScreenshotSerializer"));
const YouTubeSerializer_1 = __importDefault(require("./serializers/YouTubeSerializer"));
require("./SanityContent.css");
const Serializers = {
    types: {
        youtube: YouTubeSerializer_1.default,
        aside: AsideSerializer_1.default,
        contentImage: ImageSerializer_1.default,
        screenshot: ScreenshotSerializer_1.default,
    },
    marks: {
        internalLink: InternalLinkSerializer_1.default,
        contactUs: ContactUsSerializer_1.default,
    },
};
function SanityContent({ content }) {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ id: "sanity-content" }, { children: (0, jsx_runtime_1.jsx)(block_content_to_react_1.default, { blocks: content, serializers: Serializers }) })));
}
exports.default = SanityContent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2FuaXR5Q29udGVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2hlbHAvc2FuaXR5L1Nhbml0eUNvbnRlbnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLDRGQUV3QztBQUN4QyxvRkFBNEQ7QUFDNUQsNEZBQW9FO0FBQ3BFLG9GQUE0RDtBQUM1RCxrR0FBMEU7QUFDMUUsOEZBQXNFO0FBQ3RFLHdGQUFnRTtBQUNoRSwrQkFBNkI7QUFNN0IsTUFBTSxXQUFXLEdBQXFDO0lBQ3BELEtBQUssRUFBRTtRQUNMLE9BQU8sRUFBRSwyQkFBaUI7UUFDMUIsS0FBSyxFQUFFLHlCQUFlO1FBQ3RCLFlBQVksRUFBRSx5QkFBZTtRQUM3QixVQUFVLEVBQUUsOEJBQW9CO0tBQ2pDO0lBQ0QsS0FBSyxFQUFFO1FBQ0wsWUFBWSxFQUFFLGdDQUFzQjtRQUNwQyxTQUFTLEVBQUUsNkJBQW1CO0tBQy9CO0NBQ0YsQ0FBQztBQUVGLFNBQXdCLGFBQWEsQ0FBQyxFQUFFLE9BQU8sRUFBdUI7SUFDcEUsT0FBTyxDQUNMLDhDQUFLLEVBQUUsRUFBQyxnQkFBZ0IsZ0JBQ3RCLHVCQUFDLGdDQUFZLElBQUMsTUFBTSxFQUFFLE9BQU8sRUFBRSxXQUFXLEVBQUUsV0FBVyxHQUFJLElBQ3ZELENBQ1AsQ0FBQztBQUNKLENBQUM7QUFORCxnQ0FNQyJ9